import { render, staticRenderFns } from "./input-multiple-select.vue?vue&type=template&id=f8cdfe16&scoped=true&lang=pug&"
import script from "./input-multiple-select.vue?vue&type=script&lang=js&"
export * from "./input-multiple-select.vue?vue&type=script&lang=js&"
import style0 from "./input-multiple-select.vue?vue&type=style&index=0&id=f8cdfe16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cdfe16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
